import isEmail from 'validator/lib/isEmail';
import {validateMaxLength} from '../../common/validationUtils';

export const FbgMasterUserFormValidator = (values, props) => {
    let errors = {};

    if(!values.companyId) {
        errors.companyId = 'Nødvendig';
    }

    if (!values.workingTitle) {
        errors.workingTitle = 'Nødvendig'
    } else if (values.workingTitle.length < 3) {
        errors.workingTitle = 'Skal være 3 tegn min'
    }
    if (!values.name) {
        errors.name = 'Nødvendig';
    } else if (values.name.length < 3) {
        errors.name = 'Skal være 3 tegn min'
    }
    if (!values.email) {
        errors.email = 'Nødvendig';
    } else if (!isEmail(values.email)) {
        errors.email = 'Ugyldig emailadresse'
    }
    if (!values.phone) {
        errors.phone = 'Nødvendig';
    } else if (values.phone && !validPhoneNumber(values.phone)) {
        errors.phone = 'Ugyldigt telefonnummer'
    }
    if (values.mobilePhone && !validPhoneNumber(values.mobilePhone)) {
        errors.mobilePhone = 'Nødvendig';
    }
    if (values.directPhoneNumber && !validPhoneNumber(values.directPhoneNumber)) {
        errors.directPhoneNumber = 'Nødvendig';
    }
    if(!values.password && !props.isUpdate) {
        errors.password = 'Nødvendig';
    }
    else if(values.password && !isValidPasswordFormat(values.password)) {
        errors.password = 'Adgangskoden kan ikke være kortere end 8 symboler og skal indeholde mindst et tal, små bogstaver og stor bogstaver';
    }

    errors = validateMaxLength({values, errors, length: 255, fields: [
        'workingTitle',
        'name',
        'email',
        'password',
        'linkedIn',
        'facebook',
        'instagram',
        'twitter',
    ]});

    return errors
};

function validPhoneNumber(phone) {
    return phone.length === 8;
}

function isValidPasswordFormat(password) {
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    return regex.test(password)
}


// WEBPACK FOOTER //
// ./web/src/components/users/FbgMasterUserFormValidator.js